// extracted by mini-css-extract-plugin
export default {"page_header":"header_page_header__taDZp","breadcrumb_item":"header_breadcrumb_item__5poOV","breadcrumb_current":"header_breadcrumb_current__0Q4vW","title":"header_title__3nbMi"};